// extracted by mini-css-extract-plugin
module.exports = {"styles":"_3bvxmw8kVEtVeJagzf5kmm"};